import { SET_MENUS } from "./mutation-types";

const mutations = {
  [SET_MENUS](state, menus) {
    state.menus = menus;
  },
};

export default mutations;
